// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2C5RT","loaderOuter":"PageOverlayLoader_loaderOuter__1Kowi"};